import { useId } from 'react'

import {
  FieldContainer,
  FieldLabel,
  FieldInput,
  FieldHelperText,
} from './styled'
import { TextFieldProps } from './types'

/**
 * Labeled text input with optional helper text and error state.
 *
 * @param {TextFieldProps} props
 * @returns {JSX.Element}
 */
const TextField = ({
  label,
  errorMessage,
  helperText,
  id,
  ...inputProps
}: TextFieldProps): JSX.Element => {
  const generatedId = useId()
  const inputId = id ?? generatedId
  const hasError = errorMessage !== undefined && errorMessage !== ''
  const supplementaryText =
    hasError === true ? errorMessage : (helperText ?? '')

  return (
    <FieldContainer htmlFor={inputId}>
      <FieldLabel>{label}</FieldLabel>
      <FieldInput id={inputId} hasError={hasError} {...inputProps} />
      {supplementaryText !== '' ? (
        <FieldHelperText isError={hasError}>
          {supplementaryText}
        </FieldHelperText>
      ) : null}
    </FieldContainer>
  )
}

export default TextField
